@use "Styles/mixins";

:host {
    display: inline-block;
    box-sizing: border-box;
    flex-shrink: 0;
    width: 63px;
    height: 63px;
}

*,
*::before,
*::after {
    box-sizing: inherit;
}

.vm-video-comment-attachment-thumbnail {
    display: inline-block;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    border-radius: 8px;
    overflow: hidden;

    &__image {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 8px;
        background: mixins.get-color(background, bg-gray-50);
    }
}
